import { getAttrValue, isBoolean } from "@grandvisionhq/utils";
const getAllowBackOrder = (variant) => {
  const allowBackOrder = getAttrValue(variant, "allowBackOrder");
  return isBoolean(allowBackOrder) ? allowBackOrder : void 0;
};
export {
  getAllowBackOrder
};
//# sourceMappingURL=get-allow-back-order.js.map
